import React, {useEffect, useRef, useState} from "react";
import { observer } from "mobx-react";
import { taxAuthBillingApi } from "../../../api/taxAuthBilling.js";
import { Spinner } from "react-bootstrap";

function TaxAuthStripeCallbackPage() {
    const MAX_CHECKS = 10;
    const CHECK_INTERVAL = 3000;
    const numOfChecksDone = useRef(0);
    const [pageState, setPageState] = useState({
        waiting: true,
        payoutsEnabled: false,
    });

    useEffect(() => {
        const getBillingInfo = async () => {
            console.log("About to check if billing info is updated");

            const billingInfo = await taxAuthBillingApi.checkPayoutEnabled();
            console.log("Got results back");

            if (billingInfo.payoutEnabled) {
                setPageState((prevState) => ({
                    ...prevState,
                    waiting: false,
                    payoutsEnabled: true,
                }));
            } else {
                numOfChecksDone.current = numOfChecksDone.current + 1;

                // Schedule the next check if the maximum number of checks is not reached
                if (numOfChecksDone.current < MAX_CHECKS - 1) {
                    setTimeout(getBillingInfo, CHECK_INTERVAL);
                } else {
                    setPageState((prevState) => ({
                        ...prevState,
                        waiting: false,
                        payoutsEnabled: false,
                    }));
                }
            }
        };

        // Start the initial check
        getBillingInfo();
    }, []); // Empty dependency array to run the effect only once when the component mounts

    return (
        <div>
            <h1>Waiting for Stripe to Update your payment status</h1>
            {pageState.waiting && <Spinner />}
            {!pageState.waiting && (
                <>
                    {pageState.payoutsEnabled && (
                        <p>Stripe has successfully linked your bank account!</p>
                    )}
                    {!pageState.payoutsEnabled && (
                        <p>
                            Something may have gone wrong in the stripe setup process. Please
                            try linking your bank account again. If this problem persists,
                            please contact support@bctaxcerts.ca
                        </p>
                    )}
                </>
            )}
        </div>
    );
}

export default observer(TaxAuthStripeCallbackPage);
